import { Pencil, Trash2 } from "lucide-react";
import { ContextMenu } from "../canvas-kit/ui/context-menu.jsx";
import type { Token } from "./scene.js";

interface TokenContextMenuProps {
  token: Token;
  screenX: number;
  screenY: number;
  onRename: () => void;
  onDelete: () => void;
  onClose: () => void;
}

/**
 * Thin Tactics-specific adapter around the generic `ContextMenu`. Maps a
 * {@link Token} to the matching title + menu entries.
 */
export function TokenContextMenu({
  token,
  screenX,
  screenY,
  onRename,
  onDelete,
  onClose,
}: TokenContextMenuProps) {
  const isRegisteredPlayer = token.kind === "player" && Boolean(token.playerId);

  const title =
    token.kind === "player"
      ? token.playerId
        ? "Spieler"
        : "Dummy"
      : token.kind === "opponent"
        ? "Gegner"
        : "Ball";

  const items = [
    ...(!isRegisteredPlayer
      ? [
          {
            id: "rename",
            label:
              token.kind === "opponent" || token.kind === "player"
                ? "Nummer / Name"
                : "Beschriften",
            Icon: Pencil,
            onSelect: onRename,
          },
        ]
      : []),
    {
      id: "delete",
      label: "Entfernen",
      Icon: Trash2,
      variant: "danger" as const,
      onSelect: onDelete,
    },
  ];

  return (
    <ContextMenu
      title={title}
      items={items}
      screenX={screenX}
      screenY={screenY}
      onClose={onClose}
    />
  );
}
